import { createContext, useContext, useEffect, useState } from 'react';
import type { SchedulingVendor } from '@prisma/client';
import { useGetCurrentOrg } from 'hooks/user/use-get-current-org';
import { useSession } from 'next-auth/react';

import { isFeatureFlagEnabled } from 'utils/feature-flags';
import { logger } from 'utils/logger';

export interface Flags {
  [flag: string]: {
    enabled: '0' | '1';
    orgs?: Record<string, '0' | '1'>;
    users?: Record<string, '0' | '1'>;
    bpadmins?: '0' | '1';
    vendors?: Record<SchedulingVendor, '0' | '1'>;
  };
}

const FeatureFlagsContext = createContext<Flags>({});

type FeatureFlagsProps = React.PropsWithChildren;

export const FeatureFlagsProvider = ({ children }: FeatureFlagsProps) => {
  const [flags, setFlags] = useState({});
  useEffect(() => {
    const fetchFlags = async () => {
      const flags = await (await fetch('/api/feature-flags')).json();
      setFlags(flags || {});
    };
    fetchFlags().catch((e) => {
      logger.error(new Error("Couldn't fetch feature flags", { cause: e }));
    });
  }, []);
  return (
    <FeatureFlagsContext.Provider value={flags}>
      {children}
    </FeatureFlagsContext.Provider>
  );
};

export const useIsFeatEnabled = (feat: string) => {
  const flags = useContext(FeatureFlagsContext);
  const org = useGetCurrentOrg();
  const { data: session } = useSession();
  return isFeatureFlagEnabled(
    flags,
    feat,
    org.id,
    session?.user?.id,
    undefined,
    session?.user?.bpadmin,
  );
};
